import { render, staticRenderFns } from "./EmulatorScreenCustomization.vue?vue&type=template&id=29aa7330&scoped=true"
import script from "./EmulatorScreenCustomization.vue?vue&type=script&lang=js"
export * from "./EmulatorScreenCustomization.vue?vue&type=script&lang=js"
import style0 from "./EmulatorScreenCustomization.vue?vue&type=style&index=0&id=29aa7330&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa7330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29aa7330')) {
      api.createRecord('29aa7330', component.options)
    } else {
      api.reload('29aa7330', component.options)
    }
    module.hot.accept("./EmulatorScreenCustomization.vue?vue&type=template&id=29aa7330&scoped=true", function () {
      api.rerender('29aa7330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Emulator/EmulatorScreenCustomization.vue"
export default component.exports